import { safeSessionStorage } from "./safeStorage";

const P_SCORE_KEY = "p_score";

interface PData {
  pKey: string;
  pValue: string;
}

function extractFromUrl(searchParams: URLSearchParams): PData | null {
  const matches = Array.from(searchParams.entries()).filter(([key]) =>
    /^p\d{3}$/.test(key),
  );

  if (matches.length === 0) return null;

  const [key, value] = matches.find(([, v]) => v.length === 1) || matches[0];

  return { pKey: key, pValue: value };
}

export function extractAndSaveAbTest(
  searchParams: URLSearchParams,
): PData | null {
  const data = extractFromUrl(searchParams);
  if (data) {
    safeSessionStorage.setItem(P_SCORE_KEY, JSON.stringify(data));
    return data;
  }
  return null;
}

export function getAbTestProperties(): Record<string, string> {
  const raw = safeSessionStorage.getItem(P_SCORE_KEY);
  if (!raw) return {};

  try {
    const { pKey, pValue } = JSON.parse(raw) as PData;
    return { pKey, pValue };
  } catch {
    return {};
  }
}
